<template>
  <modal name="testPopup" :width="630" :height="730" :clickToClose="false" :draggable="true"
    @opened="opened">
    <div id="div_testPopup" class="popup on">
      <div>다이얼로그 테스트 입니다.</div>
      <div>부모창으로 부터 수신 : {{value}}</div>
      <div>부모창으로 전달할 데이터 : <input type="text" v-model="inputText"></div>

      <div class="form_box">
        <div class="btn_area">
          <a href="javascript:void(0);" class="button blue" @click="click"><span>부모로 값 전달</span></a>
          <a href="javascript:void(0);" class="button blue" @click="close"><span>닫기</span></a>
        </div>
      </div>      

      <a href="javascript:void(0);" class="pop_close" title="close" @click="close">close</a>
    </div>
  </modal>  
</template>
<script> 
export default {
  name: 'testPopup',
  props: {
    value : ""
  },
  data () {
    return {
      inputText: ''
    }
  },
  methods: {
    click(value) {
      this.$emit('input', this.inputText);
      this.$modal.hide('testPopup');
    },
    close() {
      this.$modal.hide('testPopup');
    },
    opened(e) {

      // close 버튼 표시를 위해 반드시 필요
      $("#div_testPopup").parent().css('overflow', 'visible');      
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/test/TestPopup.vue